export type TIndexableObject = {
  [key: string]: string;
};

export const VILLAGE_CLASS_NAMES: TIndexableObject = {
  business: 'Бизнес',
  comfort: 'Комфорт',
  economy: 'Эконом',
  elite: 'Элитный',
};

export const COMMUTE_TYPES: TIndexableObject = {
  kad: 'КАД',
  mkad: 'МКАД',
  none: 'центра',
};

export type TVariants = {
  [key: string]: [string, string, string];
};

export const NEW_OBJECT_VARIANTS: TVariants = {
  cottage: ['коттедж', 'коттеджа', 'коттеджей'],
  landplot: ['участок', 'участка', 'участков'],
  lowrisehouse: ['малоэтажный дом', 'малоэтажных дома', 'малоэтажных домов'],
  townhouse: ['таунхаус', 'таунхауса', 'таунхаусов'],
  houseShare: ['часть дома', 'части дома', 'частей дома'],
  totalOnSale: ['предложение', 'предложения', 'предложений'],
};

export enum NEW_OBJECTS_KEYS {
  COTTAGE = 'cottage',
  TOWNHOUSE = 'townhouse',
  LOWRISEHOUSE = 'lowrisehouse',
  LANDPLOT = 'landplot',
  HOUSESHARE = 'houseShare',
}

export const NEW_OBJECTS_COUNT_KEY: TIndexableObject = {
  [NEW_OBJECTS_KEYS.COTTAGE]: 'onSaleCottage',
  [NEW_OBJECTS_KEYS.TOWNHOUSE]: 'onSaleTownhouse',
  [NEW_OBJECTS_KEYS.LOWRISEHOUSE]: 'onSaleLowrisehouse',
  [NEW_OBJECTS_KEYS.LANDPLOT]: 'onSaleLandplot',
};

export const NEW_OBJECTS_NAMES: TIndexableObject = {
  [NEW_OBJECTS_KEYS.COTTAGE]: 'Коттеджи',
  [NEW_OBJECTS_KEYS.TOWNHOUSE]: 'Таунхаусы',
  [NEW_OBJECTS_KEYS.LOWRISEHOUSE]: 'Малоэтажные дома',
  [NEW_OBJECTS_KEYS.LANDPLOT]: 'Участки',
};

export enum VILLAGES_COUNT_KEYS {
  SELLING = 'selling',
  BUILDING = 'building',
  SOLDOUT = 'soldout',
}

export const VILLAGES_COUNT_LABELS: TIndexableObject = {
  [VILLAGES_COUNT_KEYS.BUILDING]: 'Строится',
  [VILLAGES_COUNT_KEYS.SELLING]: 'В продаже',
  [VILLAGES_COUNT_KEYS.SOLDOUT]: 'Реализовано',
};
